export const DEFAULT_STRESS_TEST_RANGES = {
    METS: {
        normal: { min: 8, max: 15 },
        mild: { min: 6, max: 7.9 },
        severe: { min: 0, max: 5.9 }
    },

    'PAS repouso': {
        normal: { min: 90, max: 129 },
        mild: { min: 130, max: 149 },
        severe: { min: 150, max: 250 }
    },

    'PAS esforço': {
        normal: { min: 140, max: 199 },
        mild: { min: 200, max: 219 },
        severe: { min: 220, max: 300 }
    },

    'Extrassístoles SV': {
        normal: { min: 0, max: 5 },
        mild: { min: 6, max: 20 },
        severe: { min: 21, max: 1000 }
    },

    'Extrassístoles V': {
        normal: { min: 0, max: 5 },
        mild: { min: 6, max: 20 },
        severe: { min: 21, max: 1000 }
    },

    'Alt. Seg. ST': {
        normal: { min: -0.5, max: 0.5 },
        mild: { min: 0.6, max: 1.0 },
        severe: { min: 1.1, max: 10 }
    },

    VO2: {
        normal: { min: 30, max: 80 },
        mild: { min: 20, max: 29.9 },
        severe: { min: 0, max: 19.9 }
    },

    Pico: {
        normal: { min: 30, max: 80 },
        mild: { min: 20, max: 29.9 },
        severe: { min: 0, max: 19.9 }
    },

    '% previsto': {
        normal: { min: 85, max: 120 },
        mild: { min: 70, max: 84.9 },
        severe: { min: 0, max: 69.9 }
    },

    VT1: {
        normal: { min: 40, max: 70 },
        mild: { min: 30, max: 39.9 },
        severe: { min: 0, max: 29.9 }
    },

    'VT1%picoVO2': {
        normal: { min: 45, max: 70 },
        mild: { min: 35, max: 44.9 },
        severe: { min: 0, max: 34.9 }
    },

    VT2: {
        normal: { min: 60, max: 90 },
        mild: { min: 45, max: 59.9 },
        severe: { min: 0, max: 44.9 }
    },

    'Quociente Resp.': {
        normal: { min: 1.1, max: 1.3 },
        mild: { min: 1.0, max: 1.09 },
        severe: { min: 0.5, max: 0.99 }
    },

    'O2 pulso % prev.': {
        normal: { min: 85, max: 120 },
        mild: { min: 70, max: 84.9 },
        severe: { min: 0, max: 69.9 }
    },

    FVC: {
        normal: { min: 80, max: 130 },
        mild: { min: 65, max: 79.9 },
        severe: { min: 0, max: 64.9 }
    },

    FEV1: {
        normal: { min: 80, max: 130 },
        mild: { min: 65, max: 79.9 },
        severe: { min: 0, max: 64.9 }
    },

    'FEV1/FVC': {
        normal: { min: 70, max: 90 },
        mild: { min: 60, max: 69.9 },
        severe: { min: 0, max: 59.9 }
    },

    'VE/VCO2': {
        normal: { min: 20, max: 30 },
        mild: { min: 31, max: 35 },
        severe: { min: 36, max: 80 }
    },

    'EqCO2 VT1': {
        normal: { min: 20, max: 30 },
        mild: { min: 31, max: 35 },
        severe: { min: 36, max: 80 }
    },

    'PETCO2 VT1': {
        normal: { min: 35, max: 45 },
        mild: { min: 30, max: 34.9 },
        severe: { min: 0, max: 29.9 }
    },

    ΔPETCO2: {
        normal: { min: 3, max: 10 },
        mild: { min: 1, max: 2.9 },
        severe: { min: 0, max: 0.9 }
    },

    FCMPI: {
        normal: { min: 85, max: 100 },
        mild: { min: 70, max: 84.9 },
        severe: { min: 0, max: 69.9 }
    },

    'Pico FC': {
        normal: { min: 85, max: 110 },
        mild: { min: 70, max: 84.9 },
        severe: { min: 0, max: 69.9 }
    },

    '% FC prevista': {
        normal: { min: 85, max: 100 },
        mild: { min: 70, max: 84.9 },
        severe: { min: 0, max: 69.9 }
    },

    '1ºmin recup': {
        normal: { min: 12, max: 40 },
        mild: { min: 8, max: 11.9 },
        severe: { min: 0, max: 7.9 }
    },

    '3ºmin recup': {
        normal: { min: 25, max: 70 },
        mild: { min: 15, max: 24.9 },
        severe: { min: 0, max: 14.9 }
    },

    '6ºmin Recup': {
        normal: { min: 40, max: 100 },
        mild: { min: 25, max: 39.9 },
        severe: { min: 0, max: 24.9 }
    }
};
